import { render } from "./loader.vue?vue&type=template&id=55e3aa6f"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import "./loader.vue?vue&type=style&index=0&id=55e3aa6f&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__